<template>
  <v-text-field
    v-model="localValue"
    outlined
    dense
    label="Issue Title"
    :rules="[rules.requiredText]"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
  import StringValue from '@/components/form/mixins/stringValue'
  import RequiredRules from '@/components/form/mixins/required'
  export default {
    name: 'FormTitleField',
    mixins: [StringValue, RequiredRules],
  }
</script>

<style lang="scss" scoped>

</style>
